/** `/:world/series`: every sub-series with its description, and the works outside them. */

import { CataloguePage, SeriesCards, usePageTitle } from '../components/Catalogue.tsx'
import { useI18n } from '../i18n/index.tsx'

export function SeriesIndex() {
  const { t } = useI18n()
  usePageTitle(t('series.index.title'))

  return (
    <CataloguePage>
      {(catalogue, world) => (
        <>
          <section className="panel wide">
            <h1>{t('series.index.title')}</h1>
            <p>{t('series.index.lead')}</p>
          </section>
          <SeriesCards catalogue={catalogue} world={world} headingLevel={2} />
        </>
      )}
    </CataloguePage>
  )
}
